import { OLHostFamilyPricePerNight } from '../../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'
import { OLHostFamilyPricePerNightInput } from '../../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night-input'

export function olHostFamilyPriceToOlHostFamilyPriceInput(
  hostFamilyPricePerNight: OLHostFamilyPricePerNight,
  overrideValues?: Partial<OLHostFamilyPricePerNightInput>
): OLHostFamilyPricePerNightInput {
  return {
    productIds: hostFamilyPricePerNight.products.map((product) => product.id),
    periodIds: hostFamilyPricePerNight.periods.map((period) => period.id),
    appliedToHost: hostFamilyPricePerNight.appliedToHost,
    currency: hostFamilyPricePerNight.currency,
    fa1ePrice: hostFamilyPricePerNight.fa1ePrice,
    fa2ePrice: hostFamilyPricePerNight.fa2ePrice,
    visitPackPerWeekPrice: hostFamilyPricePerNight.visitPackPerWeekPrice,
    otoPerHourPrice: hostFamilyPricePerNight.otoPerHourPrice,
    ...overrideValues
  }
}
